import React from "react";

const AssignDeviceType = ({ color }) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="28.807" height="24" viewBox="0 0 28.807 24">
			<path
				id="icons8-sensor_2_"
				data-name="icons8-sensor (2)"
				d="M5.473,1.906,2.016,14.059H0v2.3H3.745L4.9,12.385,7.148,25.906l3.6-11.433.432,1.89h3.475a2.76,2.76,0,0,1,0-2.3H13.017l-1.872-8.48L7.832,16.039ZM23.549,5.561l-.9,1.494a9.3,9.3,0,0,1,4.429,8.12,9.418,9.418,0,0,1-4.5,8.21l.882,1.476a11.128,11.128,0,0,0,5.347-9.686A11.026,11.026,0,0,0,23.549,5.561ZM21.263,9.612l-.936,1.458A4.89,4.89,0,0,1,22.541,15.3a4.73,4.73,0,0,1-2.215,4.051l.9,1.476a6.448,6.448,0,0,0,3.043-5.509A6.6,6.6,0,0,0,21.263,9.612Zm-3.979,3.871a1.728,1.728,0,1,0,1.728,1.728A1.732,1.732,0,0,0,17.284,13.483Z"
				transform="translate(0 -1.906)"
				fill={color || "#fff"}
			/>
		</svg>
	);
};

export default AssignDeviceType;
